import { COVERGO_SAAS_DEV, COVERGO_CA_UAT } from "../consts.js"

export const humania_dev = {
	"humania-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "humania_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}

export const humania_uat = {
	"humania-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "humania_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-humania-uat"
		}
	},
}

